window.arApisKvkRequestDetailFormatter = function(value, row) {
    let response = row.response;
    if (!response) {
        return '<em>' + __('No response') + '</em>';
    }
    try {
        response = JSON.stringify(JSON.parse(response), null, 4);
    } catch (e) {
        // Leave the response as-is when it is not valid JSON.
    }
    let html = '';
    html += '<pre class="mb-0" style="white-space: pre-wrap; word-break: break-word;">';
    html += $('<div>').text(response).html();
    html += '</pre>';
    return html;
};
